import React from 'react';
import SymbolSelectItem from './SymbolSelectItem.js';
import { isEmpty } from './functions.js';
import FontAwesome from 'react-fontawesome';



class SymbolCategory extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            allSymbolsLoaded: false
        }

        this.symbolsLoadedCount = 0;
        this.symbolsToLoadCount = 0;
        this.handleSymbolLoaded = this.handleSymbolLoaded.bind(this);
        this.handleSymbolSelect = this.handleSymbolSelect.bind(this);
    }


    handleSymbolLoaded(symbol) {
        this.symbolsLoadedCount++;

        if (this.symbolsLoadedCount >= this.symbolsToLoadCount)
        {
            this.setState({
                allSymbolsLoaded: true
            });
        }
    }
    
    handleSymbolSelect(symbol) {
        this.props.onSymbolSelect(symbol);
    }


    render() {

        let symbolSearchParam = '';
        if (!isEmpty(this.props.searchParam))
        {
            symbolSearchParam = this.props.searchParam.trim().toLowerCase();
        }

        let symbolSelects = null;
        if (this.props.symbolCategory !== null && this.props.symbolCategory.symbols !== undefined) {

            symbolSelects = [];

            for (var si = 0; si < this.props.symbolCategory.symbols.length; si++) {

                var symbol = this.props.symbolCategory.symbols[si];
                let isBlacklisted = false;

                if (!isEmpty(symbolSearchParam))
                {
                    isBlacklisted = (symbol.title.toLowerCase().indexOf(symbolSearchParam) === -1);
                }

                // check blacklist by perspective
                if (!isBlacklisted)
                {
                    isBlacklisted = symbol.isBlacklistedForPerspective(this.props.activePerspective);
                }

                // check blacklist by variant
                if (!isBlacklisted)
                {
                    isBlacklisted = symbol.isBlacklistedForVariants(this.props.activeDesignerVariants);
                }

                if (!isBlacklisted)
                {
                    symbolSelects.push(
                        <SymbolSelectItem 
                            key={symbol.id} 
                            symbol={symbol} 
                            onSymbolSelect={this.handleSymbolSelect} 
                            onSymbolLoadComplete={this.handleSymbolLoaded}
                        />
                    );
                }
            }

            this.symbolsToLoadCount = symbolSelects.length;
        }

        if (symbolSelects === null || symbolSelects.length == 0)
            return null;

        return (
            <div>
                <div className="symbol_category">
                    <span>{this.props.symbolCategory.title}</span>
                    <br />
                    {symbolSelects}
                </div>

                {
                    this.state.allSymbolsLoaded ?
                    ''
                    :
                    <div className='designer_symbolcat_loader' >
                        <div className="designer_symbolcat_loader_icon">
                            <FontAwesome
                                name='circle-o-notch'
                                size='3x'
                                spin
                            />
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default SymbolCategory;



// WEBPACK FOOTER //
// ./src/SymbolCategory.js